import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { namespace } from '@/modules/driver/namespace';

import { setDrivers } from '../actions';

const loadDrivers = createAsyncThunk(
  `${namespace}/load-drivers`,
  async (
    { limit, offset, query }: { limit: number; offset: number; query: string },
    { dispatch },
  ) => {
    const drivers = await driverAPI.fetchBriefDrivers({ limit, offset, query });

    dispatch(setDrivers(drivers));

    return drivers;
  },
);

export { loadDrivers };
